import logUtil from 'utils/log'
import updateCurrentSidebarAction from 'modules/sidebar/redux/actions/update-current'
import { SIDEBAR_ID } from 'modules/sidebar/constants'
import logEventConversionUtil from 'modules/conversion/utils/log-event'
import { CONVERSION_EVENT } from 'modules/conversion/constants'

const QUICK_SHOP = 'Quick shop'

/**
 * @param {QuickShopSidebarData} data
 * @return {(function(*): void)|*}
 */
export default function openQuickShopSidebarProductAction (data = {}) {
  return (dispatch) => {
    logUtil('openQuickShopSidebarProductAction').debug('[start] data=', data)
    logEventConversionUtil(CONVERSION_EVENT.SELECT_ITEM)

    data.title = data.title || QUICK_SHOP
    dispatch(
      updateCurrentSidebarAction(SIDEBAR_ID.QUICK_SHOP_PRODUCT, data)
    )
  }
}
